export default "__VITE_ASSET__BqxlJeJC__"